export default "__VITE_ASSET__ae667b91__"